import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';

@Injectable({ providedIn: 'root' })
export class ChartExportService {

  exportPNG(chart: any, filename = 'chart'): void {
    const url = chart.getDataURL({
      type: 'png',
      pixelRatio: 2,
      backgroundColor: '#fff'
    });
    this.downloadDataURL(url, `${filename}.png`);
  }

  exportJPEG(chart: any, filename = 'chart'): void {
    const url = chart.getDataURL({
      type: 'jpeg',
      pixelRatio: 2,
      backgroundColor: '#fff'
    });
    this.downloadDataURL(url, `${filename}.jpeg`);
  }

  exportSVG(chart: any, filename = 'chart'): void {
    const url = chart.getDataURL({
      type: 'svg',
      pixelRatio: 2,
      backgroundColor: '#fff'
    });
    this.downloadDataURL(url, `${filename}.svg`);
  }

  exportPDF(chart: any, filename = 'chart'): void {
    const imgUrl = chart.getDataURL({
      type: 'png',
      pixelRatio: 2,
      backgroundColor: '#fff'
    });

    // Use existing jsPDF from assets/js-libs
    const jsPDF = (window as any).jsPDF;
    if (jsPDF) {
      const img = new Image();
      img.onload = () => {
        const pdf = new jsPDF('landscape');
        const width = pdf.internal.pageSize.getWidth();
        const height = (img.height * width) / img.width;
        pdf.addImage(imgUrl, 'PNG', 0, 0, width, height);
        pdf.save(`${filename}.pdf`);
      };
      img.src = imgUrl;
    } else {
      // Fallback: download as PNG if jsPDF not available
      this.exportPNG(chart, filename);
    }
  }

  viewFullscreen(element: HTMLElement): void {
    if (element.requestFullscreen) {
      element.requestFullscreen();
    }
  }

  exitFullscreen(): void {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  }

  printChart(chart: any): void {
    const url = chart.getDataURL({
      type: 'png',
      pixelRatio: 2,
      backgroundColor: '#fff'
    });
    const win = window.open('');
    if (win) {
      win.document.write(`<img src="${url}" onload="window.print();window.close()" />`);
      win.document.close();
    }
  }

  private downloadDataURL(dataURL: string, filename: string): void {
    const arr = dataURL.split(',');
    const mime = arr[0].match(/:(.*?);/)?.[1] || 'application/octet-stream';
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const blob = new Blob([u8arr], { type: mime });
    saveAs(blob, filename);
  }
}
